import React from 'react';
import MainLayout from './MainLayout';
import Breadcrumb from '../components/Breadcrumb';
import { Outlet } from 'react-router-dom';

const PageLayout = () => {
  return (
    <MainLayout>
      <Breadcrumb />
      <Outlet />
    </MainLayout>
  );
};

export default PageLayout; 